import { render, staticRenderFns } from "./PaqAtencionMedica.vue?vue&type=template&id=672b9ef8&scoped=true"
import script from "./PaqAtencionMedica.vue?vue&type=script&lang=js"
export * from "./PaqAtencionMedica.vue?vue&type=script&lang=js"
import style0 from "./PaqAtencionMedica.vue?vue&type=style&index=0&id=672b9ef8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "672b9ef8",
  null
  
)

export default component.exports